import styled from 'styled-components';

export default styled.div`
  position: relative;
  height: 100%;
  overflow: ${p => !p.allowOverflow && `hidden !important`};
  display: flex;
  flex-flow: column;
`;
